import api from './api';

const reportsService = {
  // Get all reports with filters
  getAllReports: async (params = {}) => {
    const response = await api.get('/reports', { params });
    // API returns { reports: [...], pagination: {...} }
    return {
      data: response.data.reports || [],
      pagination: response.data.pagination
    };
  },

  // Get single report
  getReportById: async (id) => {
    const response = await api.get(`/reports/${id}`);
    return response.data;
  },

  // Create report
  createReport: async (data) => {
    const response = await api.post('/reports', data);
    return response.data;
  },

  // Update report
  updateReport: async (id, data) => {
    const response = await api.put(`/reports/${id}`, data);
    return response.data;
  },

  // Delete report
  deleteReport: async (id) => {
    const response = await api.delete(`/reports/${id}`);
    return response.data;
  },

  // Generate/Execute report
  generateReport: async (id) => {
    const response = await api.post(`/reports/${id}/generate`);
    return response.data;
  },

  // Report type options
  getReportTypes: () => [
    { value: 'project_status', label: 'Project Status Report' },
    { value: 'resource_utilization', label: 'Resource Utilization Report' },
    { value: 'budget_analysis', label: 'Budget Analysis Report' },
    { value: 'time_tracking', label: 'Time Tracking Report' },
    { value: 'task_progress', label: 'Task Progress Report' },
    { value: 'custom', label: 'Custom Report' }
  ],

  // Export report data to CSV
  exportToCSV: (reportData, reportName) => {
    let csvContent = '';
    
    if (reportData.projects) {
      // Project Status Report
      csvContent = 'Project Name,Code,Status,Priority,Progress,Budget Allocated,Budget Spent,Manager\n';
      reportData.projects.forEach(project => {
        csvContent += `"${project.name}","${project.code}","${project.status}","${project.priority}",${project.progress_percentage}%,${project.budget_allocated},${project.budget_spent},"${project.project_manager?.first_name} ${project.project_manager?.last_name}"\n`;
      });
    } else if (reportData.entries) {
      // Time Tracking Report
      csvContent = 'Date,User,Project,Task,Hours,Billable,Rate,Amount\n';
      reportData.entries.forEach(entry => {
        const amount = entry.is_billable && entry.hourly_rate 
          ? (parseFloat(entry.hours_spent) * parseFloat(entry.hourly_rate)).toFixed(2)
          : '0.00';
        csvContent += `"${entry.entry_date}","${entry.user?.first_name} ${entry.user?.last_name}","${entry.project?.name}","${entry.task?.title || 'N/A'}",${entry.hours_spent},${entry.is_billable ? 'Yes' : 'No'},${entry.hourly_rate || '0.00'},${amount}\n`;
      });
    } else if (reportData.tasks) {
      // Task Progress Report
      csvContent = 'Task,Project,Status,Priority,Assignee,Due Date,Progress\n';
      reportData.tasks.forEach(task => {
        csvContent += `"${task.title}","${task.project?.name}","${task.status}","${task.priority}","${task.assignee?.first_name} ${task.assignee?.last_name}","${task.due_date || 'N/A'}",${task.progress_percentage}%\n`;
      });
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${reportName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  // Export report data to JSON
  exportToJSON: (reportData, reportName) => {
    const jsonString = JSON.stringify(reportData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${reportName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.json`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export default reportsService;

